import { render, staticRenderFns } from "./Tax.vue?vue&type=template&id=6e9b5288&"
import script from "./Tax.vue?vue&type=script&lang=js&"
export * from "./Tax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports